var _path, _g, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickModeIllustrationLtr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 226,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 .907h400v224.58H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.866,
    y: 52.304,
    width: 82.682,
    height: 121.788,
    rx: 8.939,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.915 87.113.002-.003c1.092-1.12 2.939-1.124 4.066.003l3.356 3.356.003.002c1.117 1.089 1.096 2.938-.006 4.069-1.092 1.12-2.939 1.124-4.066-.003l-3.355-3.356-.003-.002c-1.121-1.092-1.124-2.94.003-4.066Zm39.16 39.16.002-.003c1.092-1.12 2.939-1.124 4.066.003l3.356 3.356.003.002c1.12 1.092 1.124 2.939-.003 4.066l-.002.003c-1.092 1.121-2.94 1.124-4.067-.003l-3.355-3.355-.003-.003c-1.12-1.092-1.124-2.939.003-4.066Zm7.424-39.16.003.002c1.12 1.092 1.124 2.94-.003 4.067l-3.356 3.355-.002.003c-1.089 1.117-2.938 1.097-4.069-.005-1.12-1.092-1.124-2.94.003-4.066l3.355-3.356.003-.003c1.092-1.12 2.939-1.124 4.066.003Zm-39.16 39.16.003.003c1.12 1.092 1.124 2.939-.003 4.066l-3.356 3.355-.002.003c-1.089 1.117-2.938 1.097-4.069-.005-1.121-1.092-1.124-2.939.003-4.066l3.355-3.356.003-.003c1.092-1.12 2.939-1.124 4.066.003Zm-9.458-12.981h-6.331a2.897 2.897 0 0 1-2.887-2.887c0-1.587 1.3-2.886 2.887-2.886h6.331a2.895 2.895 0 0 1 2.886 2.886 2.896 2.896 0 0 1-2.886 2.887Zm56.983 0h-6.331a2.897 2.897 0 0 1-2.887-2.887c0-1.587 1.3-2.886 2.887-2.886h6.331a2.896 2.896 0 0 1 2.887 2.886c0 1.587-1.3 2.887-2.887 2.887ZM294.32 85.079v-6.331c0-1.587 1.3-2.887 2.887-2.887s2.886 1.3 2.886 2.887v6.331a2.895 2.895 0 0 1-2.886 2.887 2.896 2.896 0 0 1-2.887-2.887Zm0 56.983v-6.331c0-1.587 1.3-2.886 2.887-2.886a2.895 2.895 0 0 1 2.886 2.886v6.331a2.896 2.896 0 0 1-2.886 2.887 2.897 2.897 0 0 1-2.887-2.887Z",
    fill: "#2196F3",
    fillOpacity: 0.08,
    stroke: "#fff",
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.207 95.506c-8.224 0-14.898 6.674-14.898 14.898 0 8.223 6.674 14.897 14.898 14.897 8.223 0 14.897-6.674 14.897-14.897 0-8.224-6.674-14.898-14.897-14.898Zm-4.038 21.289-5.348-5.349a1.483 1.483 0 0 1 0-2.1 1.484 1.484 0 0 1 2.101 0l4.305 4.29 10.25-10.249a1.483 1.483 0 0 1 2.1 0 1.483 1.483 0 0 1 0 2.1l-11.307 11.308c-.566.581-1.52.581-2.101 0Z",
    fill: "#2196F3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.156,
    y: 52.304,
    width: 82.682,
    height: 121.788,
    rx: 8.939,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.374 64.595a4.19 4.19 0 0 1 4.19-4.19h55.866a4.19 4.19 0 0 1 4.19 4.19v13.408a4.19 4.19 0 0 1-4.19 4.19H81.564a4.19 4.19 0 0 1-4.19-4.19V64.595ZM77.374 92.529a4.19 4.19 0 0 1 4.19-4.19h55.866a4.19 4.19 0 0 1 4.19 4.19v13.408a4.19 4.19 0 0 1-4.19 4.189H81.564a4.19 4.19 0 0 1-4.19-4.189V92.529ZM77.374 120.46a4.19 4.19 0 0 1 4.19-4.19h55.866a4.19 4.19 0 0 1 4.19 4.19v13.407a4.19 4.19 0 0 1-4.19 4.19H81.564a4.19 4.19 0 0 1-4.19-4.19V120.46ZM77.374 148.394a4.19 4.19 0 0 1 4.19-4.19h55.865a4.19 4.19 0 0 1 4.19 4.19v13.408a4.19 4.19 0 0 1-4.19 4.19H81.564a4.19 4.19 0 0 1-4.19-4.19v-13.408Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.915,
    y: 152.863,
    width: 49.162,
    height: 4.469,
    rx: 2.235,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.374 120.461a4.19 4.19 0 0 1 4.19-4.189h55.865a4.19 4.19 0 0 1 4.19 4.189v13.408a4.19 4.19 0 0 1-4.19 4.19H81.564a4.19 4.19 0 0 1-4.19-4.19v-13.408Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.915,
    y: 124.931,
    width: 49.162,
    height: 4.469,
    rx: 2.235,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.374 64.594a4.19 4.19 0 0 1 4.19-4.19h55.865a4.19 4.19 0 0 1 4.19 4.19v13.408a4.19 4.19 0 0 1-4.19 4.19H81.564a4.19 4.19 0 0 1-4.19-4.19V64.594Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.915,
    y: 69.063,
    width: 49.162,
    height: 4.469,
    rx: 2.235,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.094 92.526a4.47 4.47 0 0 1 4.47-4.469h55.865a4.47 4.47 0 0 1 4.47 4.47v13.407a4.469 4.469 0 0 1-4.47 4.469H81.564c-2.469 0-4.47-2-4.47-4.469V92.526Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.915,
    y: 96.996,
    width: 49.162,
    height: 4.469,
    rx: 2.235,
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.077 97.98a1.25 1.25 0 0 0 0 2.5v-2.5Zm114.673 16.102a1.25 1.25 0 0 0 0-1.768l-7.955-7.955a1.25 1.25 0 0 0-1.768 1.768l7.071 7.071-7.071 7.071a1.25 1.25 0 0 0 1.768 1.768l7.955-7.955Zm-57.779-7.868h1.25-1.25Zm0 0h1.25-1.25Zm-56.894-5.734h49.911v-2.5h-49.911v2.5Zm63.878 13.968h49.911v-2.5h-49.911v2.5Zm-8.234-8.234a8.234 8.234 0 0 0 8.234 8.234v-2.5a5.734 5.734 0 0 1-5.734-5.734h-2.5Zm-5.733-5.734a5.734 5.734 0 0 1 5.733 5.734h2.5a8.233 8.233 0 0 0-8.233-8.233v2.499Z",
    fill: "#A6D5FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 244.693,
    y: 42.248,
    width: 105.028,
    height: 144.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.117,
    in: "SourceAlpha",
    result: "effect1_dropShadow_106_1152"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1152"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.469
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_106_1152",
    result: "effect2_dropShadow_106_1152"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.117
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.587
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_106_1152",
    result: "effect3_dropShadow_106_1152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_106_1152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 56.983,
    y: 42.248,
    width: 105.028,
    height: 144.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.117,
    in: "SourceAlpha",
    result: "effect1_dropShadow_106_1152"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1152"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.469
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_106_1152",
    result: "effect2_dropShadow_106_1152"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.117
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.587
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_106_1152",
    result: "effect3_dropShadow_106_1152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_106_1152",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickModeIllustrationLtr);
export default __webpack_public_path__ + "static/media/quick-mode-illustration-ltr.4ab9535401be0d50331d6e7149821a84.svg";
export { ForwardRef as ReactComponent };